import React from 'react';
import { AlertTriangleIcon, NetworkIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full px-4 py-10 md:py-16 bg-[#0a0f1a]" data-id="element-82">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-83">
        {/* Card 1: The Problem */}
        <div className="bg-[#050810] border border-[#D4A843]/20 rounded-xl p-5 md:p-8" data-id="element-84">
          <div className="flex items-center gap-3 mb-4" data-id="element-85">
            <div className="bg-[#D4A843]/10 p-2 rounded-lg" data-id="element-86">
              <AlertTriangleIcon className="w-5 h-5 text-[#D4A843]" data-id="element-87" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-[#D4A843]" data-id="element-88">
              La verdad incómoda que nadie te dice
            </h2>
          </div>

          <p className="text-base md:text-lg text-gray-300 mb-3" data-id="element-89">
            La mayoría de los profesionales comete el mismo error:
          </p>

          <p className="text-lg md:text-xl font-semibold text-white mb-3 pl-4 border-l-2 border-[#D4A843]" data-id="element-90">
            👉 Trabajan donde duele.
          </p>

          <p className="text-base md:text-lg text-gray-300 mb-3" data-id="element-91">
            Y eso… es exactamente lo que mantiene el problema activo.
          </p>

          <p className="text-base md:text-lg text-gray-300 mb-1" data-id="element-92">
            Porque el dolor no es el problema.
          </p>

          <p className="text-lg md:text-xl font-bold text-white" data-id="element-93">
            Es la señal.
          </p>
        </div>

        {/* Card 2: The Solution */}
        <div className="bg-[#050810] border border-[#D4A843]/20 rounded-xl p-5 md:p-8" data-id="element-94">
          <div className="flex items-center gap-3 mb-4" data-id="element-95">
            <div className="bg-[#D4A843]/10 p-2 rounded-lg" data-id="element-96">
              <NetworkIcon className="w-5 h-5 text-[#D4A843]" data-id="element-97" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-[#D4A843]" data-id="element-98">
              La clave que cambia todo
            </h2>
          </div>

          <p className="text-base md:text-lg text-gray-300 mb-3" data-id="element-99">
            La razón por la que esto pasa es simple:
          </p>

          <p className="text-lg md:text-xl font-semibold text-white mb-4 pl-4 border-l-2 border-[#D4A843]" data-id="element-100">
            👉 No estás trabajando la fascia correctamente.
          </p>

          <p className="text-base md:text-lg text-gray-300 mb-3" data-id="element-101">
            La fascia es el sistema que conecta todo el cuerpo.
          </p>

          <ul className="space-y-2 mb-5" data-id="element-102">
            <li className="flex items-center gap-2 text-base md:text-lg text-gray-300" data-id="element-103">
              <span className="text-[#D4A843] text-lg" data-id="element-104">✓</span> Acumula tensión
            </li>
            <li className="flex items-center gap-2 text-base md:text-lg text-gray-300" data-id="element-105">
              <span className="text-[#D4A843] text-lg" data-id="element-106">✓</span> Genera
              compensaciones
            </li>
            <li className="flex items-center gap-2 text-base md:text-lg text-gray-300" data-id="element-107">
              <span className="text-[#D4A843] text-lg" data-id="element-108">✓</span> Provoca dolor…
              muchas veces lejos del origen
            </li>
          </ul>

          <div className="bg-[#0a0f1a] border-l-4 border-[#D4A843] p-4 rounded-r-lg" data-id="element-109">
            <p className="text-sm text-gray-400 mb-1" data-id="element-110">Es como una telaraña:</p>
            <p className="text-lg md:text-xl font-semibold text-white" data-id="element-111">
              Tocás un punto… y todo el sistema responde.
            </p>
          </div>
        </div>
      </div>
    </section>;
}